// extracted by mini-css-extract-plugin
export default {"disableScroll":"GbAypy","wrapper":"LzZ_Zu","overlay":"en7KZ6","modal":"wOIU4S","head":"h7MdS4","title":"CCMFZM","closeButton":"Mzc4xd"};